import { Box, Typography } from '@mui/material';

import { EmptyState } from '@/components/EmptyState';
import useUserDetails from '@/hooks/useUserDetails';

import { FeedArticleDialog } from './components/FeedArticleDialog';
import { FeedRow } from './components/FeedRow';
import { FeedSkeleton } from './components/FeedSkeleton';
import { useMonthlyRecapsPromotion } from './hooks/useMonthlyRecapsPromotion';
import { useFeedData } from './queries/useFeedData';

import type { FeedFilters } from './api/fetchFeedData';

export const Feed = ({ metadata }: { metadata: FeedFilters }) => {
  const { isUserExpired } = useUserDetails();

  const { data, isLoading } = useFeedData(metadata);

  const {
    articleDialogCTAValue,

    setArticleDialogCTAValue
  } = useMonthlyRecapsPromotion(data);

  return (
    <Box
      sx={{
        px: '8px',
        py: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        maxHeight: '650px',
        minHeight: '200px',
        overflowY: 'auto'
      }}
    >
      {isUserExpired ? (
        <Box sx={{ display: 'flex', flexGrow: 1, justifyContent: 'center', alignItems: 'center' }}>
          <Typography sx={{ textAlign: 'center' }}>
            You no longer have access.
            <br />
            Please upgrade to access Feed.
          </Typography>
        </Box>
      ) : (
        <>
          {isLoading && <FeedSkeleton />}

          {data?.length === 0 && <EmptyState />}

          {data?.map(row => (
            <FeedRow
              key={row.transactionTime + row.values.Title}
              {...row}
            />
          ))}

          {articleDialogCTAValue && (
            <FeedArticleDialog
              CTAValue={articleDialogCTAValue}
              open
              onClose={() => {
                setArticleDialogCTAValue(null);
              }}
            />
          )}
        </>
      )}
    </Box>
  );
};
